export enum ENotificationTemplateType {
  Email = 0,
  Sms = 1
}
export enum EMailTemplateType {
  Default = 0,
  ResetPassword = 1,
  SetPassword = 2,
  EmailVerfication = 3,
  TaskNotification = 4
}
